var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6352 20.7275V12.7662H16.3585L16.7671 9.66268H13.6352V7.6815C13.6352 6.78323 13.8885 6.17107 15.2032 6.17107L16.8774 6.1704V3.39446C16.5878 3.35756 15.594 3.27295 14.4373 3.27295C12.0219 3.27295 10.3683 4.71903 10.3683 7.37413V9.66268H7.63672V12.7662H10.3683V20.7275H13.6352Z",
    fill: "#2F80ED"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3207_14359",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 3,
    width: 10,
    height: 18
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6352 20.7275V12.7662H16.3585L16.7671 9.66268H13.6352V7.6815C13.6352 6.78323 13.8885 6.17107 15.2032 6.17107L16.8774 6.1704V3.39446C16.5878 3.35756 15.594 3.27295 14.4373 3.27295C12.0219 3.27295 10.3683 4.71903 10.3683 7.37413V9.66268H7.63672V12.7662H10.3683V20.7275H13.6352Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3207_14359)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.ff234ff4a2dd1e06ecab658bd8853aed.svg";
export { ForwardRef as ReactComponent };